module.exports = require('./helpers/bundle-url').getBundleURL('fJIW9') + "logo.c51670a8.svg";